import { FormBase } from "../../util/form-base-form";

class SNSUrlHiderForm extends FormBase {
    public getShowMoreButton(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".show-more-btn", HTMLElement);
    }

    public getAnchorElements(root: ParentNode): HTMLAnchorElement[] {
        return this.queryElements(root, "a", HTMLAnchorElement);
    }
}

const snsUrlHiderForm = new SNSUrlHiderForm();

export { snsUrlHiderForm };
